import React, {useEffect, useLayoutEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Colors from "../../styles/colors";
import {faPause, faPlay} from "@fortawesome/pro-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Slider} from "@material-ui/core";

interface IAscendPlayer {
    src: string,
    onFinished(): any
}

function AscendAudioPlayer(prop: IAscendPlayer){
    // styling
    const styles = makeStyles((theme) => ({
        root: {
            position: "relative",
            width: "100%",
            margin: 0,
            height: "100%",
            fontFamily: [
                'LotaGrotesque',
            ].join(','),
            display: "flex",
            alignItems: "center",
        },
        playButton:{
            position: "absolute",
            left: 0,
            fontSize: 32,
            color: Colors.primary,
        },
        progressTime: {
            width: 90,
            fontSize: 10,
            letterSpacing: 1,
            color: Colors.light,
            fontWeight: "bold",
            marginLeft: 56,
            marginBottom: 18,
        },
        startTime: {
            display: "inline-block",
            verticalAlign: "top",
            color: Colors.dark,
        },
        slash: {
            display: "inline-block",
            verticalAlign: "top",
            marginLeft: 4,
            marginRight: 2,
        },
        totalTime: {
            display: "inline-block",
            verticalAlign: "top",
        },
        track: {
            color: Colors.primary,
            position: "absolute",
            marginTop: 9,
            marginLeft: 56,
            width: "calc(100% - 64px)",
            maxWidth: 656,
            '& .MuiSlider-thumb': {
                height: 11,
                width: 11,
            },
            '& .MuiSlider-track': {
                height: 3,
            },
            '& .MuiSlider-rail': {
                height: 3,
                color: Colors.primary,
                opacity: 0.2,
            }
        },
    }));

    const [audio] = useState(new Audio(prop.src));
    const player = styles()
    const [isPlaying, togglePlay] = useState<boolean>(true)
    const [duration, setDuration] = useState<number>(0)
    const [currentTime, setCurrentTime] = useState<number>( 0)

    function formatTime(seconds: number) {
        const h = Math.floor(seconds / 3600)
        const m = Math.floor((seconds % 3600) / 60)
        const s = Math.floor(seconds % 60)
        return [h, m > 9 ? m : h ? '0' + m : m || '0', s > 9 ? s : '0' + s]
            .filter(a => a)
            .join(':')
    }

    const handleTimeUpdate = () => {
        setCurrentTime(audio.currentTime)
    }

    const handlePlayEnded = () => {
        prop.onFinished()
    }

    useEffect(() => {
            isPlaying ? audio.play() : audio.pause();
            audio.addEventListener('timeupdate', handleTimeUpdate);
            audio.addEventListener("ended", handlePlayEnded);
        return () => {
            audio.pause();
            audio.removeEventListener('timeupdate', handleTimeUpdate);
            audio.removeEventListener("ended", handlePlayEnded);
        }
    },[isPlaying, audio]);

    useLayoutEffect(() => {
        setDuration(audio.duration);
    }, [audio.duration]);



    return(
        <div className={player.root}>
            <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} className={player.playButton}
                onClick={()=>{
                    togglePlay(!isPlaying);
                }}
            />
            <div className={player.progressTime}>
                <span className={player.startTime}>{formatTime(currentTime)}</span>
                <span className={player.slash}> / </span>
                <span className={player.totalTime}>{(duration) ? formatTime(duration) : '0:00'}</span>
            </div>
            <Slider defaultValue={0}
                    value={currentTime}
                    max={duration}
                    aria-label="Default"
                    onChange={(event, v) => {
                        audio.currentTime = Number(v);
                        setCurrentTime(Number(v))
                    }}
                    step={0.5}
                    className={player.track}/>
        </div>
    );
}

export default AscendAudioPlayer